import React from "react";
import { StyledButton } from "../button/Button.style";
import styled from "styled-components";
// TODO this component is done for Tooltip but not sure it should use Button and override its styles
// https://jira.nexthink.com:1443/browse/FLASH-697
const StyledButtonGroup = styled.div.withConfig({ displayName: "StyledButtonGroup_APC-7281-productShell", componentId: "sc-v8yi21" })(({ theme }) => ({
    [`${StyledButton}`]: {
        borderRadius: "0 !important",
        backgroundColor: theme.colors.apolloColorBackgroundButtonPrimaryDefault,
        border: `1px solid ${theme.colors.apolloColorBackgroundButtonPrimaryDefault}`,
        textTransform: "none",
        "&:hover": {
            backgroundColor: theme.colors.apolloColorBackgroundButtonPrimaryHover,
            border: `1px solid ${theme.colors.apolloColorBackgroundButtonPrimaryHover}`,
        },
        "&:active": {
            backgroundColor: theme.colors.apolloColorBackgroundButtonPrimaryActive,
            border: `1px solid ${theme.colors.apolloColorBackgroundButtonPrimaryActive}`,
        },
        "&:not(:first-of-type)": {
            borderLeft: "1px solid rgba(255, 255, 255, 0.16)",
        },
    },
}));
const ButtonGroup = (props) => React.createElement(StyledButtonGroup, Object.assign({}, props));
export default ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map